import { deleteDatabase } from "store/idb";


export async function deleteDb() {
var result = await deleteDatabase();
console.log('deleteDatabase', result);
return result; // t/f
}

export async function deleteCache(cname) {
console.log('delete cache', cname);
const response = await caches.delete(cname);
const tf = await response;
console.log('cache deleted', tf);
}

export async function deleteCaches() {
//var cache = await caches.match("https://apptest.itookitwhen.com/"); //.open("workbox-precache-v2-https://apptest.itookitwhen.com/")
//console.log('cache', cache);
var keys = await caches.keys();
console.log('caches keys', keys, keys.length);
if (keys.length === 0) return;
keys.map((key) => {
    deleteCache(key);
    return true;
})
}

export async function clearData() {
console.log('clearData');
const tf = await deleteDb();
if ( !tf ) {
    console.log('Cannot delete DB');
    return;
}
localStorage.removeItem('closeApp');
localStorage.removeItem('currentUser');
await deleteCaches();
}

